<template>
  <b-sidebar
    id="add-new-user-sidebar"
    :visible="isAddNewSidebarActive"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    backdrop
    no-header
    right
    @hidden="resetForm"
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          Adicionar aula
        </h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hide"
        />
      </div>

      <!-- BODY -->
      <validation-observer
        ref="refFormObserver"
      >
        <!-- Form -->
        <b-form
          class="p-2"
          @submit.prevent="submit()"
          @reset.prevent="resetForm"
        >
          <validation-provider
            v-slot="{ errors }"
            name="title"
            rules="required"
          >
            <b-form-group
              label="Título"
              label-for="title"
            >
              <b-form-input
                id="title"
                v-model="form.title"
                :state="errors.length > 0 ? false : null"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>

          <validation-provider
            v-slot="{ errors }"
            name="description"
            rules="required"
          >
            <b-form-group
              label="Descrição"
              label-for="description"
              :state="errors.length > 0 ? false : null"
            >
              <b-form-textarea
                id="textarea-state"
                v-model="form.description"
                :state="errors.length > 0 ? false : null"
                placeholder="Descrição..."
                rows="3"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>

          <b-form-group label="Como deseja inserir a aula?">
            <v-select
              v-model="optionLesson"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              :clearable="false"
              label-field="label"
              :options="optionsLesson"
              :reduce="option => option.value"
            />
          </b-form-group>

          <!-- v-if upload -->
          <validation-provider
            v-slot="{ errors }"
            name="link"
            rules="required"
            v-if="optionLesson === 'upload'"
          >
            <b-form-group
              label="Selecionar vídeo"
              label-for="selecionar vídeo"
              :state="errors.length > 0 ? false : null"
            >
              <b-form-file
                id="upload"
                v-model="form.link"
                :state="errors.length > 0 ? false : null"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>

          <!-- v-if link -->
          <validation-provider
            v-slot="{ errors }"
            name="link"
            rules="required"
            v-if="optionLesson === 'link'"
          >
            <b-form-group
              label="Link"
              label-for="link"
              :state="errors.length > 0 ? false : null"
            >
              <b-form-input
                id="link"
                v-model="form.link"
                :state="errors.length > 0 ? false : null"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>

          <!-- Form Actions -->
          <div class="d-flex aling-items-center mt-2">
            <b-button
              v-if="optionLesson !== 'record'"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-2 d-flex align-items-center"
              type="submit"
              :disabled="isBusy"
            >
              <b-spinner style="width: 25px; height: 25px; margin-right: 8px;" class="" v-if="isBusy" />
              <span style="flex: 1;" v-if="!isBusy">Adicionar</span>
            </b-button>
            <b-button
              v-if="optionLesson === 'record'"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="success"
              class="mr-2"
              type="submit"
              :disabled="isBusy"
            >
              <b-spinner style="width: 25px; height: 25px; margin-right: 8px;" class="" v-if="isBusy" />
              <feather-icon v-if="!isBusy" icon="VideoIcon" class="mr-0" />
              <span v-if="!isBusy">Gravar aula</span>
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="button"
              variant="outline-secondary"
              @click="hide"
            >
              Cancelar
            </b-button>
          </div>
        </b-form>
      </validation-observer>
    </template>
  </b-sidebar>
</template>

<script>

import {
  BSidebar, BForm, BFormGroup, BFormInput, BButton, VBTooltip
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import Ripple from 'vue-ripple-directive'
import {
  required
} from 'vee-validate/dist/rules'
import vSelect from 'vue-select'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import LessonsServices from './lessonsServices'

extend('required', {
  ...required,
  message: 'Esse campo é obrigatório.',
})

export default {
  components: {
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BButton,
    vSelect,

    // Form Validation
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
    'b-tooltip': VBTooltip,
  },
  props: {
    isAddNewSidebarActive: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      isBusy: false,
      form: {
        title: null,
        link: null,
        module_id: null,
        thumb: null,
        description: null,        
      },
      optionLesson: null,
      optionsLesson: [
        { label: 'Selecionar vídeo', value: 'upload' },
        { label: 'Inserir link', value: 'link' },
        { label: 'Gravar aula', value: 'record' },
      ],
    }
  },
  computed: {},
  watch: {},
  created() {},
  methods: {
    handleFileChange(event) {
      const file = event.target.files[0];
      this.form.link = this.optionLesson === 'upload' ? file : null;
    },
    submit() {
      this.$refs.refFormObserver.validate().then(async (success) => {
        
        if (success) {
          
          try {
            this.isBusy = true;
            // return console.log(12)
            const formData = new FormData()

            formData.append('title', this.form.title)
            formData.append('link', this.form.link)
            formData.append('description', this.form.title)
            formData.append('module_id', this.$route.params.module_id)
            formData.append('option', this.optionLesson)

            await LessonsServices().create(formData).then(api => {
              if (api.data.status === 400) {
                
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    icon: 'InfoIcon',
                    title: api.data.message,
                    variant: 'danger',
                  }
                })
                this.isBusy = false;
              } else if (api.data.status === 200) {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: api.data.message,
                    icon: 'InfoIcon',
                    variant: 'success',
                  }
                })
                if (this.optionLesson === 'record') {
                  let lessonId = api.data.response.lesson.id
                  this.$router.push({ name: 'Recordingcourses', params: { lesson_id: lessonId } })
                }
                this.isBusy = false;
                this.$emit('close')
                this.$emit('refresh')
              }
            }).catch(err => {
              this.$toast({
                component: ToastificationContent,
                props: {
                  icon: 'InfoIcon',
                  title: err.message,
                  variant: 'danger',
                }
              })

              this.isBusy = false;
            })

            
          } catch (err) {
            this.$toast({
              component: ToastificationContent,
              props: {
                icon: 'InfoIcon',
                title: err.message,
                variant: 'danger',
              }
            })
          }
        }
      })
    },
    resetForm() {
      this.form = {
        title: null,
        link: null,
        module_id: null
      }
      this.$emit('close')
    },
    sortByName(a, b) {
      if (a.text < b.text) {
        return -1
      }
      if (a.text > b.text) {
        return 1
      }
      return 0
    },
    sortByDate(a, b) {
      if (a.date < b.date) {
        return -1
      }
      if (a.date > b.date) {
        return 1
      }
      return 0
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

#add-new-user-sidebar {
  .vs__dropdown-menu {
    max-height: 200px !important;
  }
}
</style>
